import styled from "styled-components";

export const Container = styled.div`
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 24px;
    border-top: 1px solid #e0e0e0;
`;

export const PrimaryActions = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 16px;
`;

export const ButtonPrimary = styled.div<{ disabled: boolean }>`
    border: none;
    padding: 12px 16px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: background 0.2s ease;

    background: #12619C;
    color: #fff;

    ${props => props.disabled && `
        opacity: 0.5;
        cursor: not-allowed;
    `}
`;

export const MaterialIcons = styled.span`
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
`;

export const SecondaryActions = styled.div`
    display: flex;
    gap: 6px;
    margin-bottom: 12px;
`;

export const ButtonActions = styled.button`
    display: block;
    width: 100%;
    flex: 1;
    background: white;
    color: #2196f3;
    border: 2px solid #2196f3;
    padding: 8px 10px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    transition: all 0.2s ease;

    background: #f5f5f5;
    color: #424242;
    border: 1px solid #e0e0e0;

    :disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
`;